(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3637],{

/***/ 92015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheck.js
var FaCheck = __webpack_require__(27476);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/PostItem/index.js
var PostItem = __webpack_require__(38626);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/CardVirtualOffice/index.js
var CardVirtualOffice = __webpack_require__(9203);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/HowItWorks/index.js
var HowItWorks = __webpack_require__(78354);
// EXTERNAL MODULE: ./components/organisms/PostSlider/index.js
var PostSlider = __webpack_require__(82385);
// EXTERNAL MODULE: ./components/organisms/WhyChooseUs/index.js
var WhyChooseUs = __webpack_require__(25637);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/virtual-office/index.js


















var Component = function Component(_ref) {
  var _data$banner;

  var posts = _ref.posts,
      data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-569",
        title: "Virtual Office",
        bgColor: "bg-bbc-gradient-service",
        breadcrumbs: data === null || data === void 0 ? void 0 : (_data$banner = data.banner) === null || _data$banner === void 0 ? void 0 : _data$banner.breadcrumbs,
        leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-6 text-center lg:mb-10 lg:text-left",
          children: "We help you establish your virtual office overseas to lower overhead costs, place business presence and meet company registration requirements."
        }),
        leftClassName: "relative lg:mt-0 lg:col-7",
        rightClassName: " lg:col-5 ",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/offshore/virtual-office/banner-offshore-virtual_office.png",
          width: 622,
          height: 436,
          alt: "virtual office service",
          priority: true,
          className: "w-full ",
          wrapper: {
            className: "bbc-banner-image-bottom-0"
          }
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          text: "Create your right business image",
          className: "title-h2 mb-6 text-center capitalize text-bbc-brand-800 lg:mb-10 lg:text-left"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row items-center gap-y-7",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "col-12 text-base lg:col-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "mb-6 tracking-[0.25px]",
              children: "Our virtual office packages give you the ability to easily and quickly lease an office in any of our locations throughout the world, enabling you to expand your presence with many options:"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: "mb-6 pl-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "relative mb-2 pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']",
                children: "Mailing address"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "relative mb-2 pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']",
                children: "Local telephone number/Phone handling"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "relative mb-2 pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']",
                children: "Meeting room"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "relative mb-2 pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']",
                children: "Mail forwarding"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "relative pl-4 before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-['']",
                children: "Others"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "tracking-[0.25px]",
              children: "Join online and get set up instantly with a virtual address and a local representative. With virtual offices in premier locations throughout the world, you can have the freedom to lease a workspace and work in the city of your choice \u2013 anywhere in the world!"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-4 hidden lg:block",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-yellow-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "border-b border-bbc-neutral-500 pb-8",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  text: "Premium Package",
                  className: "text-center text-3xl font-semibold uppercase leading-10 tracking-[0.25px] text-bbc-yellow-500"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "border-b border-bbc-neutral-500 pt-8 pb-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7 ",
                      children: "Prestigious mailing address"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Mail handling service"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Local telephone number /Phone handling"
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "pt-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-2 font-semibold",
                  children: "Additional services"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Scan/fax"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Meeting room"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Mail forwarding"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Others"
                    })]
                  })]
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "col-4 hidden lg:block",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "border-b border-bbc-neutral-500 pb-8",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  text: "Basic Package",
                  className: "text-center text-3xl font-semibold uppercase leading-10 tracking-[0.25px] text-bbc-brand-500"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "border-b border-bbc-neutral-500 pt-8 pb-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Prestigious mailing address"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Mail handling service"
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "pt-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-2 font-semibold",
                  children: "Additional services"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Scan/fax"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Meeting room"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative mb-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Mail forwarding"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "relative",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                      className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                      size: 12
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "inline-block pl-7",
                      children: "Others"
                    })]
                  })]
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:hidden",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
              data: ["Premium", "Basic"],
              tabListClass: {
                othersClass: "mb-6"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panels */.OK.Panels, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                  className: "focus:outline-none focus:outline-0 focus:ring-0",
                  as: "div",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "border-b border-bbc-neutral-500 pb-8",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                        as: "h3",
                        text: "Premium Package",
                        className: "text-center text-3xl font-semibold uppercase leading-10 tracking-[0.25px] text-bbc-yellow-500"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "border-b border-bbc-neutral-500 pt-8 pb-6",
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Prestigious mailing address"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Mail handling service"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Local telephone number /Phone handling"
                          })]
                        })]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "pt-6",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "mb-2 font-semibold",
                        children: "Additional services"
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Scan/fax"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Meeting room"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Mail forwarding"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-yellow-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Others"
                          })]
                        })]
                      })]
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                  className: "focus:outline-none focus:outline-0 focus:ring-0",
                  as: "div",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "rounded-3xl border-4 border-transparent bg-white px-4 py-6 hover:cursor-pointer hover:border-bbc-brand-500 hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "border-b border-bbc-neutral-500 pb-8",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                        as: "h3",
                        text: "Basic Package",
                        className: "text-center text-3xl font-semibold uppercase leading-10 tracking-[0.25px] text-bbc-brand-500"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "border-b border-bbc-neutral-500 pt-8 pb-6",
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Prestigious mailing address"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Mail handling service"
                          })]
                        })]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "pt-6",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "mb-2 font-semibold",
                        children: "Additional services"
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Scan/fax"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Meeting room"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative mb-2",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Mail forwarding"
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          className: "relative",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
                            className: "absolute left-1.5 top-1.5 text-bbc-brand-300",
                            size: 12
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "inline-block pl-7",
                            children: "Others"
                          })]
                        })]
                      })]
                    })]
                  })
                })]
              })
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(WhyChooseUs/* default */.Z, {
      title: "Why choose our virtual office service",
      sectionClassName: "bg-bbc-gradient-2 py-10 lg:py-20",
      data: data === null || data === void 0 ? void 0 : data.dataWhyChooseUs
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
      data: data === null || data === void 0 ? void 0 : data.dataMakeItWork,
      className: "mb-10 lg:mb-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
        className: "text-center font-semibold capitalize lg:text-left",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "block text-3xl text-bbc-brand-800 lg:text-bbc-40px",
          children: "Make it work"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "mt-4 block text-3xl text-bbc-brand-700 lg:leading-[44px]",
          children: "in 4 easy steps"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/offshore/virtual-office/wave_top-virtual.svg",
        width: "1920",
        height: "100",
        className: "w-full",
        wrapper: {
          className: " w-full  hidden lg:block"
        },
        alt: "Wave top"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "lg:bg-bbc-package",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container lg:pt-20 lg:pb-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            text: "Establish your worldwide presence",
            className: "title-h2 mb-3 text-center capitalize text-bbc-brand-800 lg:mb-7"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardVirtualOffice/* default */.Z, {
            data: data === null || data === void 0 ? void 0 : data.dataCountry
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-2 text-center lg:mt-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
              href: "/contact-us",
              className: "inline-block rounded-full bg-bbc-primary px-6 py-2 font-bold tracking-[0.5px] text-white transition-all duration-200 hover:bg-bbc-brand-600",
              children: "Contact Us"
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/offshore/virtual-office/wave_bottom-virtual.svg",
        width: "1920",
        height: "100",
        className: "w-full",
        wrapper: {
          className: " w-full  hidden lg:block"
        },
        alt: "Wave bottom"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:col-10 lg:mx-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z // Description="Get to know more with frequently asked questions."
          , {
            data: data === null || data === void 0 ? void 0 : data.dataFaqs
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostSlider["default"], {
          thetitle: "Industry News & Insights",
          children: posts.length > 0 && posts.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PostItem/* default */.Z, {
                post: item
              })
            }, index);
          })
        })
      })
    })]
  });
};

/* harmony default export */ var virtual_office = (Component);
Component.defaultProps = {
  data: {},
  posts: []
};
;// CONCATENATED MODULE: ./pages/offshore/virtual-office/data.json
var data_namespaceObject = JSON.parse('{"banner":{"breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Virtual Office"}]},"dataMakeItWork":[{"content":"Choose your place and service package"},{"content":"Make payment via multiple supportive methods"},{"content":"Submit necessary documents and sign application form(s)"},{"content":"Now, your virtual office is ready"}],"dataCountry":{"activeTab":0,"data":[{"name":"Hong Kong","lists":[{"country":"hongkong","img":{"src":"/assets/images/offshore/virtual-office/crawfor-house.png","width":302,"height":302},"title":"Crawford House","location":"11/F Crawford House, 70 Queen’s Road Central, Central, Hong Kong","basicPack":"59$","premiumPack":"88$"},{"country":"hongkong","img":{"src":"/assets/images/offshore/virtual-office/langham-place.png","width":302,"height":302},"title":"Langham Place","location":"25/F Langham Place Office Tower, 8 Argyle Street, Mongkok, Hong Kong","basicPack":"59$","premiumPack":"88$"},{"country":"hongkong","img":{"src":"/assets/images/offshore/virtual-office/silvercord-tower.png","width":302,"height":301},"title":"Silvercord Tower","location":"Unit 907, 9/F Silvercord Tower 2, 30 Canton Road, Tsim Sha Tsui, Hong Kong","basicPack":"59$","premiumPack":"88$"},{"country":"hongkong","img":{"src":"/assets/images/offshore/virtual-office/yen-sheng.png","width":300,"height":299},"title":"Yen Sheng","location":"6/F Yen Sheng Centre, 64 Hoi Yuen Road, Kwun Tong, Hong Kong","basicPack":"59$","premiumPack":"88$"},{"country":"hongkong","img":{"src":"/assets/images/offshore/virtual-office/times-square.png","width":300,"height":300},"title":"Times Square","location":"22/F Times Square Tower 2, 1 Matheson Street, Causeway Bay, Hong Kong","basicPack":"59$","premiumPack":"88$"},{"country":"hongkong","img":{"src":"/assets/images/offshore/virtual-office/millennium-city.png","width":300,"height":300},"title":"Millennium City","location":"15/F Millennium City 5, 418 Kwun Tong Road, Kwun Tong, Hong Kong","basicPack":"59$","premiumPack":"88$"}]},{"name":"Singapore","lists":[{"country":"singapore","img":{"src":"/assets/images/offshore/virtual-office/gsm-building.png","width":300,"height":300},"title":"GSM Building","location":"141 Middle Road #05-06 GSM Building Singapore 188976","basicPack":"49$","premiumPack":"78$"},{"country":"singapore","img":{"src":"/assets/images/offshore/virtual-office/vertex-tower-a.png","width":300,"height":300},"title":"Vertex Tower A","location":"33 Ubi Ave 3 #108-61 Vertex Tower A Singapore 408868","basicPack":"49$","premiumPack":"78$"}]},{"name":"ShangHai","lists":[{"country":"shangHai","img":{"src":"/assets/images/offshore/virtual-office/wheelock-square.png","width":300,"height":300},"title":"Wheelock Square","location":"25/F Wheelock Square, 1717 Nanjing West Road, Jing An District, Shanghai","basicPack":"59$","premiumPack":"88$"},{"country":"shangHai","img":{"src":"/assets/images/offshore/virtual-office/central-plaza.png","width":300,"height":300},"title":"Central Plaza","location":"25/F Central Plaza, 381 Huai Hai Middle Road, Huang Pu District, Shanghai","basicPack":"59$","premiumPack":"88$"},{"country":"shangHai","img":{"src":"/assets/images/offshore/virtual-office/l’avenue.png","width":300,"height":299},"title":"L’Avenue","location":"15/F L’Avenue Shanghai, 99 Xian Xia Road, Chang Ning District, Shanghai","basicPack":"59$","premiumPack":"88$"}]},{"name":"New York","lists":[{"country":"newYork","img":{"src":"/assets/images/offshore/virtual-office/grand-central.png","width":300,"height":300},"title":"Grand Central","location":"100 Park Avenue, Manhattan, New York, 10017","basicPack":"129$","premiumPack":"158$"},{"country":"newYork","img":{"src":"/assets/images/offshore/virtual-office/bryan-park.png","width":300,"height":300},"title":"Bryant Park","location":"104 West 40th Street, Suites 400 and 500, New York City, New York, 10018","basicPack":"129$","premiumPack":"158$"},{"country":"newYork","img":{"src":"/assets/images/offshore/virtual-office/one-liberty-plaza.png","width":300,"height":300},"title":"One Liberty Plaza","location":"165 Broadway,23rd Floor, New York City, New York, 10006","basicPack":"129$","premiumPack":"158$"},{"country":"newYork","img":{"src":"/assets/images/offshore/virtual-office/260-madison.png","width":300,"height":300},"title":"260 Madison","location":"260 Madison Avenue, 8th Floor, Manhattan, New York, 10016","basicPack":"129$","premiumPack":"158$"},{"country":"newYork","img":{"src":"/assets/images/offshore/virtual-office/broad-street.png","width":300,"height":300},"title":"Broad Street","location":"80 Broad Street, 5th Floor, Manhattan, New York, 10004","basicPack":"129$","premiumPack":"158$"},{"country":"newYork","img":{"src":"/assets/images/offshore/virtual-office/brookfield-place.png","width":300,"height":300},"title":"Brookfield Place","location":"200 Vessey Street, 24th Floor, New York City, New York, 10281","basicPack":"129$","premiumPack":"158$"}]}]},"dataFaqs":[{"name":"What billing options do I have?","content":"<p>You can settle payment via debit/credit card, Paypal, or bank transfer. Billing cycle includes yearly billing only.</p>"},{"name":"What is included in virtual office package?","content":"<p>Basic package includes</p><ul><li>Mailing address</li><li>Mail handling service</li></ul><p>Premium package includes</p><ul><li>Mailing address</li><li>Mail handling service</li><li>Local telephone number/Phone handling</li></ul><p>Following services would come with an extra fee beyond the basic price on a pay-per-use basis.</p><ul><li>Scan/Fax</li><li>Meeting room</li><li>Mail forwarding</li><li>Others</li></ul>"},{"name":"How can I manage my virtual office account?","content":"<p>You will receive the dedicated virtual office account management with one point of contact to accommodate all your needs. Through this point of contact, you can modify your virtual office preferences and set up your virtual office account instructions as well as virtual office billing.</p>"},{"name":"What if I need a temporary place for meeting with clients or partners?","content":"<p>In addition to your virtual office business address and message handling, you will have access to the BBCIncorp meeting room network on a pay-per-use basis. This service is great for those times when you need to conduct business face to face. Your virtual office membership gives you priority access to meeting rooms in any of our prestigious business center locations.</p>"}],"dataWhyChooseUs":[{"icon":{"src":"/assets/icons/mail-switch.svg","altText":"service icon"},"title":"Enhanced brand image","description":"Strengthen your professional business image with prestigious mailing address"},{"icon":{"src":"/assets/icons/location-user.svg","altText":"location-user icon"},"title":"Convenience & privacy","description":"A registered address for receiving government and banking documents"},{"icon":{"src":"/assets/icons/companies-available.svg","altText":"companies-available icon"},"title":"Cost efficency","description":"Facilitate penetration or new market testing with manageable cost"},{"icon":{"src":"/assets/icons/hand-earth.svg","altText":"hand-earth icon"},"title":"Increased flexibility","description":"Ability to work at home or wherever you are"},{"icon":{"src":"/assets/icons/users-shield.svg","altText":"users-shield icon"},"title":"Add-on services","description":"Many supporting options provided ranging from very basic mailing address to advanced packages"}]}');
;// CONCATENATED MODULE: ./pages/offshore/virtual-office/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    page: data === null || data === void 0 ? void 0 : data.page,
    locationRouter: "offshore",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(virtual_office, {
      data: data_namespaceObject,
      posts: data === null || data === void 0 ? void 0 : data.posts
    })
  });
}

/***/ }),

/***/ 63370:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/virtual-office",
      function () {
        return __webpack_require__(92015);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,8352,4090,9738,7447,9156,2753,2888,179], function() { return __webpack_exec__(63370); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);